export const productShortName = 'Process Control & SCADA Systems — Professional Edition';
export const productBrand = 'Process Control & SCADA Systems';
export const productEdition = 'Professional Edition';
export const productImage = 'https://cdn.magicpatterns.com/uploads/fcevJop9E5bK55FPrSHYRi/MOCKUP_SCADA.png';
export const productImageAlt =
  'Process Control & SCADA Systems Professional Edition: six volumes covering control loops, PID and tuning, DCS systems, SCADA and RTUs, protocols and networks, and HMI, alarms and security, plus five bonus resources';

export const checkoutUrl = 'https://process-control-scada-systems.impultienda.ar/checkout';

export const price = 'USD 27.00';
export const priceBefore = 'USD 80.00';

export const totalVolumes = 6;
export const totalBonuses = 5;
export const bonusValue = '$14';
export const bonusTotalValue = '$70';

export const closingLines = [
  'No more confusion about how a control loop really works',
  'No more guessing when a loop oscillates or needs tuning',
  'No more uncertainty about DCS and SCADA architecture',
  'No more gaps in understanding industrial protocols and networks',
  'No more stress over alarms, communication failures and troubleshooting',
];
